module.exports = __webpack_public_path__ + "static/media/one2.31344f4e.png";